import { useGetApplication } from '../../../../../hooks';

import { baseUrl } from './http';
import { type ReportVersion } from './types';

export function useGetAllReportVersions(id: string) {
  const [{ data, loading, error, response }] = useGetApplication<Array<ReportVersion>>({
    url: baseUrl + '/all/' + id,
    params: {}
  });

  return { loading, data: data, error, response };
}

export function useGetReportVersion(id: string) {
  const [{ data, loading, error, response }] = useGetApplication<ReportVersion>({
    url: baseUrl + '/' + id,
    params: {}
  });

  return { loading, data: data, error, response };
}
